var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "CSChatThai", staticStyle: { background: "#2562af" } },
    [
      _c(
        "div",
        { staticStyle: { background: "#2562af !important", padding: "10px" } },
        [
          _c(
            "v-btn",
            {
              staticStyle: { margin: "0 !important" },
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.goback()
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "white--text",
                  staticStyle: { "font-size": "24px" }
                },
                [_vm._v("chevron_left")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                color: "white",
                "font-weight": "800",
                "margin-left": "25vw"
              }
            },
            [_vm._v("เพิ่มเพื่อน")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "createGroupStyle",
          on: {
            click: function($event) {
              return _vm.gotopath("/create_group")
            }
          }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs2: "", xl2: "", lg2: "", md2: "", sm2: "" } },
                [
                  _c(
                    "v-avatar",
                    { attrs: { color: "white", size: "40px" } },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "font-size": "24px" },
                          attrs: { color: "#909090" }
                        },
                        [_vm._v("mdi-account-group")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs9: "", xl9: "", lg9: "", md9: "", sm9: "" } },
                [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        color: "#4e4e4ec2",
                        "margin-bottom": "0 !important",
                        "margin-left": "10px",
                        "font-weight": "800 !important"
                      }
                    },
                    [_vm._v("สร้างกลุ่ม")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#909090c9",
                        "margin-bottom": "0 !important",
                        "margin-left": "10px",
                        "font-size": "12px"
                      }
                    },
                    [_vm._v("สร้างกลุ่มสำหรับคุณและเพื่อน")]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            padding: "10px",
            cursor: "pointer",
            background: "#fafafa"
          }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", xl12: "", lg12: "", md12: "", sm12: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      solo: "",
                      placeholder: "ค้นหาเพื่อน",
                      "prepend-inner-icon": "fas fa-search",
                      "hide-details": "",
                      height: "35"
                    },
                    on: {
                      input: function($event) {
                        return _vm.searchUser()
                      }
                    },
                    model: {
                      value: _vm.searchText,
                      callback: function($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", xl12: "", lg12: "", md12: "", sm12: "" } },
                [
                  _vm.stateSearch
                    ? _c(
                        "div",
                        [
                          _vm.listUser.length > 0
                            ? _c(
                                "v-list",
                                {
                                  staticStyle: {
                                    height: "60vh",
                                    overflow: "scroll",
                                    "margin-top": "10px"
                                  },
                                  attrs: { "two-line": "" }
                                },
                                [
                                  _vm._l(_vm.listUser, function(item, index) {
                                    return [
                                      _c(
                                        "v-list-tile",
                                        {
                                          attrs: { avatar: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectRoom_userOnline(
                                                item.username
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-avatar",
                                            {
                                              attrs: {
                                                color: "#2562af",
                                                size: "40"
                                              }
                                            },
                                            [
                                              !item.profile_picture
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "white--text headline"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              " +
                                                          _vm._s(
                                                            item["display_name"]
                                                              .length >= 2
                                                              ? item[
                                                                  "display_name"
                                                                ].charAt(0) +
                                                                  item[
                                                                    "display_name"
                                                                  ].charAt(1)
                                                              : item[
                                                                  "display_name"
                                                                ].charAt(0)
                                                          )
                                                      )
                                                    ]
                                                  )
                                                : _c("img", {
                                                    attrs: {
                                                      src:
                                                        _vm.backend +
                                                        item.profile_picture
                                                    }
                                                  })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", {
                                                staticClass: "CSChatThai",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    item["display_name"]
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", {
                                                staticClass: "CSChatThai",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    item["email"]
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      index != _vm.listUser.length - 1
                                        ? _c("v-divider")
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            : _vm.searchText.length < 3
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "margin-top": "10px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n    ต้องค้นหาตั้งแต่ 3 ตัวอักษรขึ้นไป\n  "
                                  )
                                ]
                              )
                            : _c(
                                "p",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "margin-top": "10px"
                                  }
                                },
                                [_vm._v("\n    ไม่พบเพื่อนที่ต้องการค้นหา\n  ")]
                              )
                        ],
                        1
                      )
                    : _c(
                        "p",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "margin-top": "10px"
                          }
                        },
                        [_vm._v("\n    ค้นหาเพื่อนของคุณ จากอีเมลหรือชื่อ\n  ")]
                      )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-761bae97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761bae97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/Addfriend.vue
// module id = null
// module chunks = 